import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Technologygcc = () => {
  return (
    <div
      className="tabing_section healthcare_tabs_sec p-100"
      style={{ background: "#F8F8F8" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={9} lg={8} className="m-auto text-center">
            <h3 className="h3_head">
              Our Tech-Stack for <span>2D Game</span> Development Services
            </h3>
            <p>
              Our 2D game development company thrives with disruption and
              innovation – so does our game development toolchain. We use novel,
              high-performance technologies to meet new-age gaming demands and
              solve challenges our clients face.
            </p>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Design & Prototyping">
              <ul>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/2d-game/design/Figma.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Figma</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/2d-game/design/Godot.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Godot</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/2d-game/design/Unity.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Unity</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/2d-game/design/Aseprite.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Aseprite</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="Art & Animation">
              <ul>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/2d-game/art/Harmony.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Harmony</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/2d-game/art/Krita.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Krita</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/2d-game/art/Photoshop.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Photoshop</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/2d-game/art/Spine.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Spine</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="Programming">
              <ul>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/2d-game/programming/C#.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>C#</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/2d-game/programming/Git.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Git</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/2d-game/programming/VS.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Visual Studio</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="4" title="Sound Design & Music">
              <ul>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/2d-game/sound-design/Ableton.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Ableton</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/2d-game/sound-design/Audacity.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Audacity</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/2d-game/sound-design/BFXR.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>BFXR</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/2d-game/sound-design/FMOD.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>BFXR</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="5" title="Testing">
              <ul>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/2d-game/testing/AppLovin_SDK.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>AppLovin SDK</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/2d-game/testing/Google_Play_Console.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Google Play Console</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/2d-game/testing/Steamworks.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Steamworks</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/2d-game/testing/Unity.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Unity</h6>
                  </div>
                </li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
